import { Component, OnDestroy, OnInit } from '@angular/core';

import { PubSubService } from '../../../core/services/communication/pubsub/pubsub.service';
import { NavigationService } from '../../../core/services/navigation/navigation.service';
import { AbstractOutletComponent } from '../../../shared/components/abstractOutlet/abstract-outlet.component';

@Component({
    selector: 'insights-main',
    templateUrl: './insights-main.component.html',
    standalone: false,
})
export class InsightsMainComponent extends AbstractOutletComponent implements OnInit, OnDestroy {
    constructor(
        public pubSub: PubSubService,
        protected navigationService: NavigationService,
    ) {
        super();
        this.navigationService.emitChangeSource.next(true as unknown as null);
    }

    override ngOnInit(): void {
        this.pubSub.subscribe('insightsMainLoader', this.pubSub.API.INSIGHTS_MAIN_LOADING, () => {
            this.hideSpinner();
        });
    }

    override ngOnDestroy() {
        this.pubSub.unsubscribe('insightsMainLoader');
    }
}
